<app-template-text
  (onblur)="onblur.emit()"
  [counter]="counter"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [maxlength]="maxlength"
  [label]="label"
  [required]="required"
/>
